import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

const styles = {
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  },
  pageSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  loadingIndicator: {
    marginLeft: '8px',
    color: '#1976d2',
  },
  countersRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
  },
  counterCard: (color) => ({
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    borderLeft: `4px solid ${color}`,
  }),
  counterLabel: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px',
  },
  counterValue: {
    fontSize: '1.75rem',
    fontWeight: '700',
    color: '#333',
  },
  filtersCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 250px',
  },
  filterLabel: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: '600',
    marginBottom: '6px',
  },
  searchInput: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  filterSelect: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  clearButton: {
    padding: '10px 18px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '500',
    whiteSpace: 'nowrap',
  },
  btnPesquisar: {
    padding: '8px 20px',
    backgroundColor: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  tableCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  tableResponsive: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.9rem',
  },
  th: {
    padding: '12px 16px',
    textAlign: 'left',
    fontWeight: '600',
    color: '#666',
    backgroundColor: '#fafafa',
    borderBottom: '2px solid #eee',
    fontSize: '0.8rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    userSelect: 'none',
  },
  td: {
    padding: '12px 16px',
    color: '#333',
    borderBottom: '1px solid #f0f0f0',
    verticalAlign: 'middle',
  },
  trEven: {
    backgroundColor: '#fafafa',
  },
  badgeAtivo: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: '600',
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
  },
  badgeBloqueado: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: '600',
    backgroundColor: '#ffebee',
    color: '#c62828',
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#999',
  },
  loadingState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#666',
    fontSize: '1rem',
  },
};

function Convenios() {
  const navigate = useNavigate();
  const [convenios, setConvenios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [tipoFilter, setTipoFilter] = useState('');
  const [cidadeFilter, setCidadeFilter] = useState('');
  const [tabelaFilter, setTabelaFilter] = useState('');
  const [filterOptions, setFilterOptions] = useState({ tipos: [], cidades: [] });
  const [totalItems, setTotalItems] = useState(0);
  const [contadores, setContadores] = useState({ total: 0, ativos: 0, bloqueados: 0, comTabela: 0 });
  const [hoveredRow, setHoveredRow] = useState(null);

  // Initial fetch on mount
  useEffect(() => {
    fetchConvenios();
  }, []);

  const handleSearch = () => {
    fetchConvenios();
  };

  const fetchConvenios = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (searchTerm) params.append('search', searchTerm);
      if (statusFilter) params.append('bloqueado', statusFilter);
      if (tipoFilter) params.append('tipo', tipoFilter);
      if (cidadeFilter) params.append('cidade', cidadeFilter);
      if (tabelaFilter) params.append('comTabela', tabelaFilter);

      const response = await axios.get(`${API_URL}/convenios?${params.toString()}`);
      const data = response.data.data || (Array.isArray(response.data) ? response.data : []);
      setConvenios(data);
      setTotalItems(data.length);
      setFilterOptions(response.data.filters || { tipos: [], cidades: [] });

      const ativos = data.filter(c => c.BLOQUEADO !== 'T').length;
      const bloqueados = data.filter(c => c.BLOQUEADO === 'T').length;
      const comTabela = data.filter(c => c.TOTAL_EXAMES > 0).length;
      setContadores({ total: data.length, ativos, bloqueados, comTabela });
    } catch (err) {
      console.error('Erro ao buscar convenios:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatCNPJ = (value) => {
    if (!value) return '-';
    const cnpj = value.replace(/\D/g, '');
    if (cnpj.length === 14) {
      return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    }
    return value;
  };

  const hasFilters = searchTerm || statusFilter || tipoFilter || cidadeFilter || tabelaFilter;

  if (loading && convenios.length === 0) {
    return <div style={styles.loadingState}>Carregando convenios...</div>;
  }

  return (
    <div className="data-page" style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', fontFamily: 'Inter, Roboto, "Open Sans", sans-serif' }}>
      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🏦</span>
          <div>
            <h1 style={styles.pageTitle}>Convenios</h1>
            <p style={styles.pageSubtitle}>
              Exibindo {convenios.length} de {totalItems} registros
              {hasFilters && ' (filtrado)'}
              {loading && <span style={styles.loadingIndicator}> Carregando...</span>}
            </p>
          </div>
        </div>
      </div>

      {/* Contadores */}
      <div className="responsive-grid" style={styles.countersRow}>
        <div style={styles.counterCard('#1976d2')}>
          <div style={styles.counterLabel}>Total</div>
          <div style={styles.counterValue}>{contadores.total}</div>
        </div>
        <div style={styles.counterCard('#2e7d32')}>
          <div style={styles.counterLabel}>Ativos</div>
          <div style={{ ...styles.counterValue, color: '#2e7d32' }}>{contadores.ativos}</div>
        </div>
        <div style={styles.counterCard('#c62828')}>
          <div style={styles.counterLabel}>Bloqueados</div>
          <div style={{ ...styles.counterValue, color: '#c62828' }}>{contadores.bloqueados}</div>
        </div>
        <div style={styles.counterCard('#7b1fa2')}>
          <div style={styles.counterLabel}>Com Tabela</div>
          <div style={{ ...styles.counterValue, color: '#7b1fa2' }}>{contadores.comTabela}</div>
        </div>
      </div>

      {/* Filtros */}
      <div className="responsive-flex page-filters" style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Buscar</label>
          <input
            type="text"
            placeholder="Nome, codigo ou CNPJ..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
            style={styles.searchInput}
          />
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 160px' }}>
          <label style={styles.filterLabel}>Status</label>
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={styles.filterSelect}>
            <option value="">Todos</option>
            <option value="F">Ativos</option>
            <option value="T">Bloqueados</option>
          </select>
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 160px' }}>
          <label style={styles.filterLabel}>Tipo</label>
          <select value={tipoFilter} onChange={(e) => setTipoFilter(e.target.value)} style={styles.filterSelect}>
            <option value="">Todos</option>
            {filterOptions.tipos.map(t => <option key={t} value={t}>{t}</option>)}
          </select>
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 200px' }}>
          <label style={styles.filterLabel}>Cidade</label>
          <select value={cidadeFilter} onChange={(e) => setCidadeFilter(e.target.value)} style={styles.filterSelect}>
            <option value="">Todas</option>
            {filterOptions.cidades.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 180px' }}>
          <label style={styles.filterLabel}>Tabela de Precos</label>
          <select value={tabelaFilter} onChange={(e) => setTabelaFilter(e.target.value)} style={styles.filterSelect}>
            <option value="">Todos</option>
            <option value="S">Com tabela</option>
            <option value="N">Sem tabela</option>
          </select>
        </div>
        <button style={styles.btnPesquisar} onClick={handleSearch}>
          Pesquisar
        </button>
        {hasFilters && (
          <button
            style={styles.clearButton}
            onClick={() => { setSearchTerm(''); setStatusFilter(''); setTipoFilter(''); setCidadeFilter(''); setTabelaFilter(''); }}
          >
            Limpar Filtros
          </button>
        )}
      </div>

      {/* Tabela Desktop */}
      <div className="convenios-desktop" style={styles.tableCard}>
        <div style={styles.tableResponsive}>
          <table className="data-table" style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, width: '80px' }}>Codigo</th>
                <th style={styles.th}>Razao Social</th>
                <th style={{ ...styles.th, width: '160px' }}>CNPJ</th>
                <th style={{ ...styles.th, width: '130px' }}>Telefone</th>
                <th style={{ ...styles.th, width: '80px', textAlign: 'center' }}>Tipo</th>
                <th style={{ ...styles.th, width: '90px', textAlign: 'center' }}>Exames</th>
                <th style={{ ...styles.th, width: '90px', textAlign: 'center' }}>Com Valor</th>
                <th style={{ ...styles.th, width: '90px', textAlign: 'center' }}>Sem Valor</th>
                <th style={{ ...styles.th, width: '100px', textAlign: 'center' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {convenios.length === 0 ? (
                <tr>
                  <td colSpan="9" style={styles.emptyState}>
                    Nenhum convenio encontrado.
                  </td>
                </tr>
              ) : (
                convenios.map((convenio, index) => (
                  <tr
                    key={convenio.IDENTIFICACAO || index}
                    style={{
                      ...(index % 2 === 0 ? {} : styles.trEven),
                      ...(hoveredRow === index ? { backgroundColor: '#e3f2fd' } : {}),
                      cursor: 'pointer',
                      transition: 'background-color 0.15s',
                    }}
                    onClick={() => navigate(`/convenios/${convenio.IDENTIFICACAO}`)}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td style={{ ...styles.td, fontWeight: '600' }}>{convenio.IDENTIFICACAO}</td>
                    <td style={styles.td}>{convenio.RAZAOSOCIAL || '-'}</td>
                    <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '0.85rem' }}>{formatCNPJ(convenio.CGC)}</td>
                    <td style={styles.td}>{convenio.TELEFONE || '-'}</td>
                    <td style={{ ...styles.td, textAlign: 'center', fontSize: '0.85rem' }}>{convenio.TIPO || '-'}</td>
                    <td style={{ ...styles.td, textAlign: 'center', fontWeight: '600', color: convenio.TOTAL_EXAMES > 0 ? '#1976d2' : '#ccc' }}>
                      {convenio.TOTAL_EXAMES || '-'}
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center', fontWeight: '600', color: convenio.COM_VALOR > 0 ? '#2e7d32' : '#ccc' }}>
                      {convenio.COM_VALOR || '-'}
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center', fontWeight: '600', color: convenio.SEM_VALOR > 0 ? '#e65100' : '#ccc' }}>
                      {convenio.SEM_VALOR || '-'}
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>
                      <span style={convenio.BLOQUEADO === 'T' ? styles.badgeBloqueado : styles.badgeAtivo}>
                        {convenio.BLOQUEADO === 'T' ? 'Bloqueado' : 'Ativo'}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile: Cards */}
      <div className="convenios-mobile">
        {convenios.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
            Nenhum convenio encontrado.
          </div>
        ) : (
          convenios.map((convenio, index) => {
            const bloqueado = convenio.BLOQUEADO === 'T';
            const cnpj = convenio.CGC ? formatCNPJ(convenio.CGC) : null;
            const telefone = convenio.TELEFONE || null;
            const tipo = convenio.TIPO || null;
            const totalExames = convenio.TOTAL_EXAMES || 0;
            const comValor = convenio.COM_VALOR || 0;
            const semValor = convenio.SEM_VALOR || 0;

            return (
              <div
                key={convenio.IDENTIFICACAO || index}
                className="convenio-card"
                onClick={() => navigate(`/convenios/${convenio.IDENTIFICACAO}`)}
              >
                <div className="convenio-card-header">
                  <span className="convenio-card-codigo">{convenio.IDENTIFICACAO}</span>
                  <span className={`convenio-card-status ${bloqueado ? 'bloqueado' : 'ativo'}`}>
                    {bloqueado ? 'Bloqueado' : 'Ativo'}
                  </span>
                </div>
                <div className="convenio-card-nome">{convenio.RAZAOSOCIAL || '-'}</div>
                <div className="convenio-card-meta">
                  {cnpj && cnpj !== '-' && <span>CNPJ: {cnpj}</span>}
                  {telefone && <span>Tel: {telefone}</span>}
                  {tipo && <span>Tipo: {tipo}</span>}
                </div>
                <div className="convenio-card-stats">
                  <span className="stat-total">{totalExames} exames</span>
                  <span className="stat-valor">{comValor} com valor</span>
                  <span className="stat-sem">{semValor} sem valor</span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default Convenios;
